import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'
import paymentOptionsReducer from './paymentOptionsReducer'

const productPackagesReducer = combineReducers({
  byId: createByIdReducer('productPackage'),
  allIds: createAllIdsReducer('productPackage'),
  indexIds: createIndexIdsReducer('productPackage'),
  meta: createMetaReducer('productPackage'),
  paymentOptions: paymentOptionsReducer,
  loading: (state = false, action) => {
    switch (action.type) {
      case 'PRODUCT_PACKAGE_REQUEST':
        return true
      case 'CREATE_PRODUCTPACKAGE':
      case 'CREATE_PRODUCTPACKAGE_FAILURE':
      case 'UPDATE_PRODUCTPACKAGE_SUCCESS':
      case 'UPDATE_PRODUCTPACKAGE_FAILURE':
        return false
      default:
        return state
    }
  },
})

/**
 * On reset of the application, clear all productPackage state to start fresh.
 *
 * @param {object} state - The current productPackages state.
 * @param {object} action - The dispatched Redux action.
 * @returns {object} The next productPackages state.
 */
export default function reducer(state, action) {
  if (action.type === 'RESET_REFI_APPLICATION_DATA') {
    return productPackagesReducer(undefined, action)
  }
  return productPackagesReducer(state, action)
}

// SELECTORS

export const selectProductPackageList = (state) => {
  return state.allIds.map((id) => state.byId[id]) || []
}

export const selectProductPackageIndex = (state) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectProductPackageMeta = (state) => {
  return state.meta || {}
}

export const selectProductPackage = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}

export const selectProductPackagePaymentOptions = (state) => {
  return state.productPackages.paymentOptions
}

/**
 * Loading indicator for creating/updating a product package.
 *
 * @param {object} state - Redux root state
 * @returns {boolean} true if a product package is in flight
 */
export const selectProductPackageLoading = (state) => {
  return state.productPackages.loading
}
